module.exports = __webpack_public_path__ + "media/images/qr/classy-e5c588aec7940afcb88409dd1c4e3141.png";